import axios from "axios";
import { ToIso8601Format } from "../helper/func";
var result = { Status: true, Message: "", Data: null };
export const saveProductInfo = async (values, sellPrice,companyId ) => {

    var result = { Status: true, Message: "", Data: null };   
    var data = {
        ProductName: values.productName,
        CompanyId : companyId,
        SellPrice: parseFloat(sellPrice),
        BuyPrice: parseFloat(values.buyPrice),
        TypeId: values.Type.value,
        OperatorId: values.Operator.value,
        IsActive: values.isActive,
        IsEpin: values.isEpin,
        IsRenew: values.isRenew,
        Specification: values.specification,
        Expire: values.expire ? ToIso8601Format(values.expire) : null, 
        ExpireInfo: values.expireInfo ?  values.expireInfo : '',
        RegionId: values.Coverage.value,
        Tag: Array.isArray(values.tag) ? values.tag.join(',') : '', //fix (';') to (',')
        Currency: values.currency,
        Margin: parseInt(values.margin),
        RoamskuId: values.roamskuId,
        ProductCode: values.productCode                             
    }

    if (values.productId === '' || values.productId === null) {
        try {

            const response = await axios.post(`/api/Product/Create`, data);
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    } else {
        data.ProductId = values.productId;
        try {
            const response = await axios.put(`/api/Product/${data.ProductId}`, data)
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    }
}

export const getProductImportList = async (companyId, currentPage, rowPerPage, startDate, endDate) => {
    let response;
    const data = {
        CompanyId: companyId,
        CurrentPage: currentPage,
        RowPerPage: rowPerPage,
        StartDate: startDate,
        EndDate: endDate,
    };
    try {
        response = await axios.post(`/api/Product/GetProductImportList`, data);
        if (response && response.status === 200) return response.data;
        return response.status;
    } catch (error) {
        if (error.response && error.response.status === 401) return error.response.status;
    }
};

export const importProducts = async (payload) => {
    var result = { Status: false, Message: "", Data: null };
    try {
        const response = await axios.post(`/api/Product/ImportProducts`, payload);
        if (response && response.status === 200) {
            return response.data;
        }
        result.Message = "Import Product Failed";
        return result;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            return 401;
        }
        result.Message = "Unhandled exception";
        return result;
    }
};

export const GetProductList = async (values,currentPage,rowPerPage,operatorId,typeId,searchQuery) => {
    let response;
    var data = {
        CompanyId : values,
        CurrentPage: currentPage,
        RowPerPage: rowPerPage,
        OperatorId: operatorId,
        TypeId: typeId,
        SearchQuery: searchQuery || ""
    }
    try {
            response = await axios.post(`/api/Product/GetProductList`, data);
        
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}


export const GetProductById = async (id) => {
    try {
        // var data = {
        //     ProductId: parseInt(id),
        // }
        const response = await axios.post(`/api/Product/GetProductById`,{ id: id});

        if (response && response.status === 200) {
            return response.data;
        } else {
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}

export const GetRegionAndcountries = async (id) => {
    try {
        const response = await axios.post(`/api/Product/GetRegionAndcountries`,{ id: id});

        if (response && response.status === 200) {
            return response.data;
        } else {
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}

export const GetProducts = async (companyId) => {
    let response;
    var data = {
        CompanyId : companyId,
    }
    try {
            response = await axios.post(`/api/Product/GetProducts`, data);
        
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}

export const GetProductsForHome = async (operator,type,region,min,max,sortBy,currentPage,rowPerPage,searchQuery) => {
    let response;
    var data = {
        OperatorId: operator.value,
        TypeId: type.value,
        RegionId: region.value,
        Min: min,
        Max: max,
        SortBy: sortBy,
        CurrentPage: currentPage,
        RowPerPage: rowPerPage,
        SearchQuery: searchQuery,

    }
    try {
            response = await axios.post(`/api/Product/GetProductsForHome`, data);
        
        if (response && response.status === 200) {
            // console.log("Response product home",response.data);
            return response.data;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}

export const GetMinMaxPrice = async (operator,type,region,searchQuery) => {
    let response;
    var data = {
        OperatorId: operator.value,
        TypeId: type.value,
        RegionId: region.value,
        SearchQuery: searchQuery

    }
    try {
            response = await axios.post(`/api/Product/GetMinMaxPrice`, data);
        
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}



export const deleteProduct = async (values) => {
    try {
        var data = {
            ProductId: values.productId,
        }
        const response = await axios.post(`/api/Product/Delete`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        console.log(error)
    }
}

export const GetRegionList = async () => {
    let response;
    try {
            response = await axios.post(`/api/Product/GetRegionList`);
        
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}


export const GetCountryList = async () => {
    let response;
    try {
            response = await axios.post(`/api/Product/GetCountryList`);
        
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}

export const BuyNow = async (productDetail) => {
    let response;
    try {
            response = await axios.post(`/api/esim/order`, productDetail);
    
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("ProductDetail Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}